<template>
  <!-- 授权文章音频制作发行权 -->
  <div class="audioProduction">
      <p>龙源果实享有期刊杂志音视频制作发行权<br>助力新媒体加速布局内容产业赋能</p>
      <ul>
          <li v-for="(item,index) in listDate" :key="index">
              <div class="imgWarp">
                  <img :src="item.img"/>
              </div>
              <span>{{item.title}}</span>
          </li>
      </ul> 
      <div class="footer_textTwo">
        <img src="@/assets/home/yinyueshouquan.png" alt="">
        &nbsp;<span>Ting</span>&nbsp;
        <b>杂志</b>
      </div>
      <div class="footer_text">听时事、听财经、听文摘、听故事........</div>
  </div>
</template>

<script>
  export default {
    name: 'audioProduction',
    data () {
      return {
        listDate:[
            {title:"发现",img:require("@/assets/home/faxian.png"),path:""},
            {title:"音频转授",img:require("@/assets/home/yinpinshouquan.png"),path:""},
            {title:"获取授权",img:require("@/assets/home/huoqushouquan.png"),path:""}
        ]
      }
    },
    methods:{
        
    },
    mounted(){ 
    }
  }
</script>

<style scoped lang="less">
.audioProduction{
    p{
        color:rgba(21,47,106,1);
        line-height:38px;
        font-size:24px;
        text-align: center;
    }
    ul{
      width: 560px;
      margin: auto;
      display: flex;
      padding:40px 0 120px 0;
      justify-content: space-between;
      li{
        width: 120px;
        text-align: center;
        img{
          width: 120px;
          height: 120px;
        }
        span{
          font-size:24px; 
          font-weight:600;
          color:rgba(66,71,108,1);
          line-height:38px;
        }
      }
    }
    .footer_textTwo{
      display: flex;
      justify-content: center;
      align-items: center;
      height: 42px;
      img{
        height: 100%;
      }
      span{
        color: #50AEFE;
        font-size: 48px;
        font-weight:600;
      }
      b{
        color:#42476C;
        font-size: 36px;
      }
    }
    .footer_text{
      padding:40px 0 80px 0;
      text-align: center;
      font-size: 20px;
      height:24px;  
      font-weight:400;
      color:rgba(21,47,106,1);
      line-height:24px;
    }
}

</style>



// WEBPACK FOOTER //
// src/page/home/homeComponents/audioProduction.vue